import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Less } from '@/views/Bera/_components/Filter/Fields/RPN/Less';
import { Greater } from '@/views/Bera/_components/Filter/Fields/RPN/Greater';
import { ComparisonField } from '@/views/Bera/_components/Filter/Fields/ComparisonField';

import type { BeraFilterFormFields } from '@/views/Bera/types';

const { useFormInstance } = Form;

export function RPN(): JSX.Element {
	const form = useFormInstance<BeraFilterFormFields>();

	function handleClear(): void {
		const clearedFields = { min_rpn: undefined, max_rpn: undefined };

		form.setFieldsValue(clearedFields);
	}

	return (
		<ComparisonField
			name="type_rpn"
			label={I18n.get('RPN')}
			minimum={<Greater />}
			maximum={<Less />}
			onClear={handleClear}
		/>
	);
}
